const collectUrlParams = (urlParams) => {
  const params = [];
  const paramsToExclude = ['page'];

  // eslint-disable-next-line no-restricted-syntax
  for (const [column, value] of urlParams.entries()) {
    if (!paramsToExclude.includes(column)) {
      params.push({ column, value });
    }
  }

  return params;
};

const params = ({ searchParams, page, domainId }, domainKey) =>
  searchParams.size
    ? {
        'filter[]': [
          collectUrlParams(searchParams).reduce((accumulator, currentValue) => {
            if (!accumulator) {
              return JSON.stringify(currentValue);
            }
            return `${accumulator}&filter[]=${JSON.stringify(currentValue)}`;
          }, ''),
        ],
        page,
        domainId,
        domainKey,
      }
    : { page, domainId, domainKey };

export default params;
